export const rooms = [
  {
    path: '/rooms',
    component: () => import(/* webpackChunkName: "rooms" */ '@/views/rooms/Rooms'),
  },
]
